import { IConfiguration } from "../../../domain/configuration";
import {
  IUserRegistry,
  IUserRepository,
  IProfessionRepository,
  IDesignatedDoctorRepository,
  IUserSelectionRepository,
  IUserRestrictionService,
  User,
} from "../../../domain/user";
import { UserRestrictionService } from "../UserRestrictionService";
import {
  UserRepository,
  ProfessionRepository,
  DesignatedDoctorRepository,
  UserSelectionRepository,
} from ".";

export class UserRegistry implements IUserRegistry {
  constructor(private _getConfiguration: () => IConfiguration, private _getUser: () => User, private _getToken: () => string) {
  }

  getUserRepository(): IUserRepository {
    return new UserRepository(this._getToken);
  }

  getProfessionRepository(): IProfessionRepository {
    return new ProfessionRepository(this._getToken);
  }

  getDesignatedDoctorRepository(): IDesignatedDoctorRepository {
    return new DesignatedDoctorRepository(this._getToken);
  }

  getUserSelectionRepository(): IUserSelectionRepository {
    return new UserSelectionRepository(this._getToken);
  }

  getRestrictionService(): IUserRestrictionService {
    return new UserRestrictionService(this._getConfiguration, this._getUser);
  }
}
